module.exports = __webpack_public_path__ + "img/yandex.29dcadf7.svg";